export const json = {
  locale: 'hi_in',
  recipe: "रेसिपी",
  machine: "मशीन",
  task: {
    state: {
      unset: "अनिर्धारित",
      todo: "करने के लिए",
      in_progress: "प्रगति में",
      to_test: "परीक्षण के लिए",
      wont_fix: "ठीक नहीं होगा",
      done: "पूर्ण",
      paused: "रोका गया",
    },
    priority: {
      unset: "कोई प्राथमिकता नहीं",
      low: "कम",
      normal: "सामान्य",
      high: "उच्च",
      max: "अत्यावश्यक",
    },
    table: {
      header: {
        title: "कार्य",
        state: "स्थिति",
        priority: "प्राथमिकता",
        labels: "लेबल",
      },
      placeholder: {
        filter: {
          priority: "ईमेल फ़िल्टर करें...",
        },
      },
      "no-results": "कोई परिणाम नहीं",
    },
    add: {
      title: "नया कार्य जोड़ें",
      name: "कार्य का नाम",
      name_placeholder: "कार्य का नाम दर्ज करें",
      priority: "प्राथमिकता",
      title_translations: "शीर्षक अनुवाद",
      description_translations: "विवरण अनुवाद",
      icon_url: "आइकन URL (वैकल्पिक)",
      icon_url_placeholder: "आइकन URL दर्ज करें",
      labels: "लेबल",
      assigned_to: "को सौंपा गया",
      assigned_to_placeholder: "मॉडरेटर चुनें",
      submit: "कार्य बनाएं",
      cancel: "रद्द करें",
      edit_translations: "अनुवाद संपादित करें",
      save_translations: "अनुवाद सहेजें",
      required_field: "यह फ़ील्ड आवश्यक है",
      en_us_required: "अंग्रेजी (US) अनुवाद आवश्यक है",
      success: "कार्य सफलतापूर्वक बनाया गया!",
      error: "कार्य बनाने में त्रुटि। कृपया पुनः प्रयास करें।",
    },
  },
  table: {
    select: {
      of: "का",
      rows: "पंक्ति(याँ) चयनित।",
    },
  },
  cookies: {
    link: 'कुकी नीति',
    title: "कुकी सहमति",
    description:
      "यह वेबसाइट अपने उचित कार्य को सुनिश्चित करने और आपके अनुभव को बेहतर बनाने के लिए कुकीज़ का उपयोग करती है। कृपया चुनें कि आप हमें किन कुकीज़ का उपयोग करने की अनुमति देते हैं।",
    policy_link: "हमारी कुकी नीति में अधिक जानें",
    accept_all: "सभी स्वीकार करें",
    accept_selected: "चयनित स्वीकार करें",
    accept_essential: "केवल आवश्यक",
    manage: "प्राथमिकताएँ प्रबंधित करें",
    save: "प्राथमिकताएँ सहेजें",
    back: "वापस",
    categories: {
      essential: {
        title: "आवश्यक कुकीज़",
        description: "ये कुकीज़ वेबसाइट के कार्य के लिए आवश्यक हैं और इन्हें अक्षम नहीं किया जा सकता।",
      },
      functional: {
        title: "कार्यात्मक कुकीज़",
        description: "ये कुकीज़ व्यक्तिगत सुविधाओं और कार्यक्षमता को सक्षम करती हैं।",
      },
      analytics: {
        title: "विश्लेषण कुकीज़",
        description: "ये कुकीज़ हमें यह समझने में मदद करती हैं कि आगंतुक वेबसाइट के साथ कैसे बातचीत करते हैं।",
      },
      marketing: {
        title: "मार्केटिंग कुकीज़",
        description: "ये कुकीज़ विज्ञापन उद्देश्यों के लिए वेबसाइटों पर आगंतुकों को ट्रैक करने के लिए उपयोग की जाती हैं।",
      },
    },
    expiration: {
      title: "कुकी समाप्ति",
      description: "चुनें कि आपकी कुकी प्राथमिकताएँ कितने समय तक याद रखी जाएंगी:",
      thirty_days: "30 दिन",
      ninety_days: "90 दिन",
      six_months: "6 महीने",
      one_year: "1 वर्ष",
    },
    policy: {
      title: "कुकी नीति",
      introduction:
        "यह कुकी नीति बताती है कि हम आपको पहचानने के लिए कुकीज़ और समान तकनीकों का उपयोग कैसे करते हैं जब आप हमारी वेबसाइट पर आते हैं। यह बताती है कि ये तकनीकें क्या हैं और हम उनका उपयोग क्यों करते हैं, साथ ही उनके उपयोग को नियंत्रित करने के आपके अधिकार भी।",
      what_are_cookies: "कुकीज़ क्या हैं?",
      what_are_cookies_text:
        "कुकीज़ छोटे डेटा फ़ाइलें हैं जो आपके कंप्यूटर या मोबाइल डिवाइस पर रखी जाती हैं जब आप किसी वेबसाइट पर जाते हैं। कुकीज़ का उपयोग वेबसाइट मालिकों द्वारा अपनी वेबसाइटों को काम करने के लिए, या अधिक कुशलता से काम करने के लिए, साथ ही रिपोर्टिंग जानकारी प्रदान करने के लिए व्यापक रूप से किया जाता है।",
      how_we_use: "हम कुकीज़ का उपयोग कैसे करते हैं",
      how_we_use_text:
        "हम कई कारणों से कुकीज़ का उपयोग करते हैं। कुछ कुकीज़ तकनीकी कारणों से हमारी वेबसाइट के संचालन के लिए आवश्यक हैं, और हम इन्हें 'आवश्यक' या 'जरूरी' कुकीज़ कहते हैं। अन्य कुकीज़ हमें अपने उपयोगकर्ताओं के हितों को ट्रैक करने और लक्षित करने की अनुमति देती हैं ताकि हमारी वेबसाइट पर अनुभव को बेहतर बनाया जा सके। तीसरे पक्ष विज्ञापन, विश्लेषण और अन्य उद्देश्यों के लिए हमारी वेबसाइट के माध्यम से कुकीज़ प्रदान करते हैं।",
      types: "हम जिन प्रकार की कुकीज़ का उपयोग करते हैं",
      managing: "अपनी कुकीज़ का प्रबंधन",
      managing_text:
        "आप कुकीज़ को स्वीकार या अस्वीकार करने के लिए अपने वेब ब्राउज़र नियंत्रण सेट या संशोधित कर सकते हैं। यदि आप कुकीज़ को अस्वीकार करने का चयन करते हैं, तो आप अभी भी हमारी वेबसाइट का उपयोग कर सकते हैं, हालांकि हमारी वेबसाइट की कुछ कार्यक्षमता और क्षेत्रों तक आपकी पहुंच प्रतिबंधित हो सकती है। चूंकि वे साधन जिनके द्वारा आप अपने वेब ब्राउज़र नियंत्रणों के माध्यम से कुकीज़ को अस्वीकार कर सकते हैं, ब्राउज़र-से-ब्राउज़र भिन्न होते हैं, आपको अधिक जानकारी के लिए अपने ब्राउज़र की सहायता मेनू देखना चाहिए।",
      third_party: "तृतीय-पक्ष कुकीज़",
      third_party_text:
        "अपनी स्वयं की कुकीज़ के अलावा, हम वेबसाइट उपयोग के आंकड़ों की रिपोर्ट करने, वेबसाइट पर और उसके माध्यम से विज्ञापन वितरित करने, और इसी तरह के लिए विभिन्न तृतीय-पक्ष कुकीज़ का भी उपयोग कर सकते हैं।",
      updates: "इस कुकी नीति के अपडेट",
      updates_text:
        "हम समय-समय पर इस कुकी नीति को अपडेट कर सकते हैं ताकि, उदाहरण के लिए, हमारे द्वारा उपयोग की जाने वाली कुकीज़ में परिवर्तन या अन्य परिचालन, कानूनी या नियामक कारणों को प्रतिबिंबित किया जा सके। इसलिए, कृपया कुकीज़ और संबंधित तकनीकों के हमारे उपयोग के बारे में सूचित रहने के लिए नियमित रूप से इस कुकी नीति को फिर से देखें।",
      purpose: "उद्देश्य",
      essential_purpose:
        "वेबसाइट के उचित कार्य के लिए आवश्यक। ये कुकीज़ पृष्ठ नेविगेशन और वेबसाइट के सुरक्षित क्षेत्रों तक पहुंच जैसे बुनियादी कार्यों को सक्षम करती हैं।",
      functional_purpose:
        "वेबसाइट को आपके द्वारा किए गए विकल्पों (जैसे आपका उपयोगकर्ता नाम, भाषा या वह क्षेत्र जिसमें आप हैं) को याद रखने और बेहतर, अधिक व्यक्तिगत सुविधाएं प्रदान करने की अनुमति देती हैं।",
      analytics_purpose:
        "हमें यह समझने में मदद करती हैं कि आगंतुक हमारी वेबसाइट के साथ कैसे बातचीत करते हैं, गुमनाम रूप से जानकारी एकत्र करके और रिपोर्ट करके।",
      marketing_purpose:
        "वेबसाइटों पर आगंतुकों को ट्रैक करने के लिए उपयोग की जाती हैं। इरादा ऐसे विज्ञापन दिखाना है जो व्यक्तिगत उपयोगकर्ता के लिए प्रासंगिक और आकर्षक हों।",
      always_active: "हमेशा सक्रिय",
      active: "सक्रिय",
      inactive: "निष्क्रिय",
      back_to_site: "साइट पर वापस जाएं",
    },
  },
  sidebar: {
    platform: "प्लेटफॉर्म",
    dashboard: "डैशबोर्ड",
    tasks: {
      title: "कार्य",
      add: "कार्य जोड़ें"
    },
    analytics: "विश्लेषिकी",
    users: "उपयोगकर्ता",
    settings: "सेटिंग्स",
    admin_panel: {
      title: "एडमिन पैनल",
      mods: {
        title: "मॉडरेटर्स",
        add: "मॉडरेटर जोड़ें"
      },
      labels: {
        title: "लेबल",
        add: "लेबल जोड़ें"
      },
      pending: "लंबित अनुमोदन"
    },
    documentation: {
      title: "दस्तावेज़ीकरण",
      create: "दस्तावेज़ीकरण बनाएं"
    },
    search: "दस्तावेज़ों में खोजें..."
  },
  pages: {
    user: {
      tabs: {
        overview: {
          title: "अवलोकन",
          userInfo: "उपयोगकर्ता जानकारी",
          userId: "उपयोगकर्ता आईडी",
          role: "भूमिका",
          memberSince: "सदस्य कब से"
        },
        tasks: {
          title: "कार्य",
          assigned: "सौंपे गए कार्य",
          noTasks: "अभी तक कोई कार्य सौंपा नहीं गया है।"
        },
        activity: {
          title: "गतिविधि",
          recent: "हाल की गतिविधि",
          noActivity: "कोई हाल की गतिविधि नहीं है।"
        },
        settings: {
          title: "सेटिंग्स",
          user: "उपयोगकर्ता सेटिंग्स",
          admin: "इस उपयोगकर्ता के लिए एडमिन सेटिंग्स।"
        }
      }
    },
    mods: {
      error: {
        unknownError: "अज्ञात त्रुटि"
      },
      access: {
        title: "पहुंच अस्वीकृत",
        description: "आपके पास इस पृष्ठ तक पहुंचने की अनुमति नहीं है।"
      },
      add: {
        link: "नया मॉड जोड़ें",
        title: "नया मॉड जोड़ें",
        addDesc: "एक नया मॉड एंट्री बनाएं",
        name: {
          title: "नाम",
          placeholder: "मॉड का नाम दर्ज करें"
        },
        description: {
          title: "विवरण",
          placholder: "विवरण दर्ज करें "
        },
        optional: "वैकल्पिक",
        versions: {
          title: "संस्करण",
          add: "संस्करण जोड़ें"
        },
        icon: "आइकन URL",
        launchers: "लॉन्चर्स",
        form: {
          errors: {
            alert: {
              title: "त्रुटि",
              description: "कृपया सबमिट करने से पहले ऊपर की त्रुटियों को ठीक करें।"
            },
            name: "नाम आवश्यक है",
            description: "अंग्रेजी (US) विवरण आवश्यक है",
            curseforge: "CurseForge लिंक आवश्यक है",
            invalidURL: "अमान्य URL प्रारूप",
            versions: "कम से कम एक संस्करण आवश्यक है",
            launchers: "कम से कम एक लॉन्चर आवश्यक है"
          }
        },
        cancel: "रद्द करें",
        create: {
          loading: "बना रहा है...",
          default: "मॉड बनाएं"
        },
        langDataError: "भाषा डेटा लोड करने में त्रुटि:",
      },
      noMods: "कोई मॉड नहीं मिला",
      getStarted: "एक नया मॉड बनाकर शुरू करें।",
      fetch: {
        error: 'दस्तावेज़ीकरण लाने में त्रुटि:'
      },
      "delete": {
        link: "हटाएं",
        confirm: "क्या आप वाकई इस मॉड को हटाना चाहते हैं?"
      },
      toast: {
        delete: {
          success: {
            title: "मॉड हटाया गया",
            description: "मॉड सफलतापूर्वक हटा दिया गया है।"
          },
          error: {
            console: "मॉड हटाने में त्रुटि:",
            fallback: "मॉड हटाने में विफल",
            title: "त्रुटि",
            description: "मॉड हटाते समय एक त्रुटि हुई।"
          }
        },
        edit: {
          success: {
            title: "सफलता",
            description: "मॉड सफलतापूर्वक अपडेट किया गया"
          }
        },
        add: {
          fallback: "मॉड बनाने में विफल",
          success: {
            title: "सफलता",
            description: "मॉड सफलतापूर्वक बनाया गया"
          },
          console: "मॉड बनाने में त्रुटि:",
          error: {
            title: "त्रुटि",
            description: "मॉड बनाने में विफल"
          }
        }
      },
      noDesc: "कोई विवरण उपलब्ध नहीं",
      docs: {
        link: "दस्तावेज़"
      },
      edit: {
        link: "संपादित करें",
        title: "मॉड संपादित करें",
        langDataError: "भाषा डेटा लोड करने में त्रुटि:",
        notFound: "मॉड नहीं मिला",
        failFetch: "मॉड लाने में विफल",
        unknownError: "एक अज्ञात त्रुटि हुई",
        form: {
          errors: {
            name: "नाम आवश्यक है",
            description: "अंग्रेजी (US) विवरण आवश्यक है",
            curseforge: "CurseForge लिंक आवश्यक है",
            versions: "सभी संस्करण फ़ील्ड भरे जाने चाहिए",
            launchers: "कम से कम एक लॉन्चर का चयन किया जाना चाहिए"
          }
        },
        modInfo: "मॉड जानकारी",
        editModInfo: "मॉड की जानकारी संपादित करें।",
        name: "नाम",
        description: {
          title: "विवरण",
          required: "अंग्रेजी (US) विवरण आवश्यक है।"
        },
        optional: "वैकल्पिक",
        versions: {
          title: "संस्करण",
          add: "संस्करण जोड़ें",
          remove: "हटाएं"
        },
        icon: "आइकन URL",
        launchers: "लॉन्चर्स",
        cancel: "रद्द करें",
        update: "मॉड अपडेट करें"
      }
    },
    docs: {
      access: {
        title: "पहुंच अस्वीकृत",
        description: "आपके पास इस पृष्ठ तक पहुंचने की अनुमति नहीं है।"
      },
      title: "दस्तावेज़ीकरण",
      description: "माइनक्राफ्ट मॉड्स के लिए दस्तावेज़ीकरण ब्राउज़ करें और पढ़ें",
      create: {
        link: "दस्तावेज़ीकरण बनाएं",
        tab: "नया बनाएं",
        content: {
          title: "कोई मॉड उपलब्ध नहीं",
          description: "सभी मॉड्स के पास पहले से ही दस्तावेज़ीकरण है या आपके पास किसी भी मॉड के लिए दस्तावेज़ीकरण बनाने की अनुमति नहीं है।"
        },
        title: "दस्तावेज़ीकरण बनाएं"
      },
      published: "प्रकाशित",
      pending: "लंबित",
      noDocs: {
        title: "कोई दस्तावेज़ीकरण उपलब्ध नहीं",
        description: "अभी तक कोई प्रकाशित दस्तावेज़ीकरण पृष्ठ नहीं हैं।"
      },
      noPending: {
        title: "कोई लंबित दस्तावेज़ीकरण नहीं",
        superAdmin: "अनुमोदन के लिए कोई दस्तावेज़ीकरण पृष्ठ प्रतीक्षारत नहीं हैं",
        rest: "आपके पास कोई लंबित दस्तावेज़ीकरण पृष्ठ नहीं हैं।"
      },
      user: {
        noDocs: {
          title: "कोई दस्तावेज़ीकरण उपलब्ध नहीं",
          description: "अभी तक कोई प्रकाशित दस्तावेज़ीकरण पृष्ठ नहीं हैं।"
        }
      },
      card: {
        pending: "अनुमोदन के लिए लंबित",
        view: "देखें",
        edit: "संपादित करें"
      },
      add: {
        title: "नया दस्तावेज़ीकरण बनाएं",
        description: "माइनक्राफ्ट मॉड के लिए व्यापक दस्तावेज़ीकरण बनाएं",
        noMods: {
          title: "कोई मॉड उपलब्ध नहीं",
          description: "दस्तावेज़ीकरण बनाने के लिए कोई मॉड उपलब्ध नहीं है। या तो सभी मॉड्स के पास पहले से ही दस्तावेज़ीकरण है या आपके पास किसी भी मॉड के लिए दस्तावेज़ीकरण बनाने की अनुमति नहीं है।"
        },
        card: {
          title: "बुनियादी जानकारी",
          description: "दस्तावेज़ीकरण के बारे में बुनियादी जानकारी प्रदान करें।",
          descriptionLink: "हमारी दस्तावेज़ीकरण गाइड देखें",
          content: {
            modSelect: "एक मॉड चुनें",
            modSelectDesc: "वह मॉड चुनें जिसके लिए आप दस्तावेज़ीकरण बनाना चाहते हैं",
            noDesc: "कोई विवरण उपलब्ध नहीं",
            form: {
              title: {
                title: "शीर्षक",
                placeholder: "दस्तावेज़ीकरण शीर्षक दर्ज करें",
                description: "आपके दस्तावेज़ीकरण का शीर्षक (अंग्रेजी US आवश्यक है)"
              },
              description: {
                title: "विवरण",
                placeholder: "दस्तावेज़ीकरण विवरण दर्ज करें",
                description: "आपके दस्तावेज़ीकरण का संक्षिप्त विवरण (अंग्रेजी US आवश्यक है)"
              },
              coverImage: {
                title: "कवर इमेज URL (वैकल्पिक)",
                description: "अपने दस्तावेज़ीकरण के कवर इमेज के लिए एक URL प्रदान करें"
              },
              tabs: {
                preview: {
                  title: "पूर्वावलोकन",
                  content: {
                    title: "पूर्वावलोकन",
                    description: "आपका दस्तावेज़ीकरण कैसा दिखेगा इसका पूर्वावलोकन",
                    form: {
                      title: "दस्तावेज़ीकरण शीर्षक",
                      description: "दस्तावेज़ीकरण विवरण यहां दिखाई देगा।"
                    },
                    section: "अनुभाग",
                    article: "लेख",
                    modSelect: {
                      title: "एक मॉड चुनें",
                      description: "अपने दस्तावेज़ीकरण का पूर्वावलोकन देखने के लिए एक मॉड चुनें"
                    }
                  }
                },
                information: {
                  title: "जानकारी",
                  content: {
                    title: "जानकारी",
                    description: "दस्तावेज़ीकरण बनाने के बारे में महत्वपूर्ण जानकारी",
                    approval: {
                      title: "अनुमोदन आवश्यक",
                      description: "संपादकों और प्रशासकों द्वारा बनाए गए दस्तावेज़ीकरण को सार्वजनिक होने से पहले सुपर एडमिन से अनुमोदन की आवश्यकता होती है। इसका अनुरोध करने के लिए एक टिकट खोलें।"
                    },
                    after: {
                      title: "बनाने के बाद:",
                      list: {
                        one: "आपको दस्तावेज़ीकरण संपादक पर पुनर्निर्देशित किया जाएगा",
                        two: "एक डिफ़ॉल्ट अनुभाग और लेख स्वचालित रूप से बनाया जाएगा",
                        three: "आप आवश्यकतानुसार अधिक अनुभाग और लेख जोड़ सकते हैं",
                        four: "आप छवियां अपलोड कर सकते हैं और कस्टम कंपोनेंट्स जोड़ सकते हैं",
                        five: "आप अनुमोदन के लिए सबमिट करने से पहले अपने दस्तावेज़ीकरण का पूर्वावलोकन कर सकते हैं। (पूर्वावलोकन से पहले इसे सहेजा जाना चाहिए)"
                      }
                    },
                    create: {
                      loading: "बना रहा है...",
                      default: "दस्तावेज़ीकरण बनाएं"
                    }
                  }
                }
              }
            }
          }
        },
        fetch: {
          mods: "मॉड्स लाने में विफल",
          documentation: "दस्तावेज़ीकरण लाने में विफल"
        },
        success: {
          title: "दस्तावेज़ीकरण बनाया गया",
          description: "आपका दस्तावेज़ीकरण सफलतापूर्वक बनाया गया है।"
        },
        error: {
          fetching: {
            mods: {
              console: "मॉड्स लाने में त्रुटि:",
              toast: {
                title: "त्रुटि",
                description: "मॉड्स लोड करने में विफल। कृपया पुनः प्रयास करें।"
              }
            }
          },
          creating: {
            failed: "दस्तावेज़ीकरण बनाने में विफल",
            error: {
              console: "दस्तावेज़ीकरण बनाने में त्रुटि:",
              toast: {
                title: "त्रुटि",
                description: "दस्तावेज़ीकरण बनाने में विफल। कृपया पुनः प्रयास करें।"
              }
            }
          }
        }
      }
    }
  }
}